import { useState } from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { localStorage } from '@fiverr-private/futile';
import { ResellingPrograms } from '../../../type';
import { getSelectedCountryStorageKey } from '../../../lib/cookies';

interface UseSelectCountrySliceArgs {
    sellerName: string;
    countries: ResellingPrograms['countries'];
}

export const useSelectedCountrySlice = ({ sellerName, countries }: UseSelectCountrySliceArgs) => {
    const storedCountry: string | null = localStorage.get(getSelectedCountryStorageKey(sellerName));

    const [selectedCountry, setSelectedCountry] = useState(() => {
        const defaultCountry = countries[0];

        if (countries.length === 1) {
            return defaultCountry;
        }

        if (storedCountry && countries.includes(storedCountry)) {
            return storedCountry;
        }

        const { countryCode } = getContext();
        if (countries.includes(countryCode)) {
            return countryCode;
        }

        return defaultCountry;
    });

    const handleSelectCountry = (code: string) => {
        localStorage.set(getSelectedCountryStorageKey(sellerName), code);
        setSelectedCountry(code);
    };

    return { selectedCountry, onSelectCountry: handleSelectCountry };
};
